/**
 * Obtain information about the current environment.
 *
 * @todo - Obtain SSO URL from PHP when the `SSOConfig` class is moved to the
 *        `qustodio-core` plugin (currently in the `qustodio-divi-expension`
 *        plugin).
 */

const environment = () => {
  const getSSOUrl = () => {
    if (qustodioCore.currentEnvironment === 'pro') {
      return 'https://auth.qustodio.com';
    }
    if (qustodioCore.currentEnvironment === 'pre') {
      return 'https://auth-pre.qustodio.com';
    }
    return 'https://auth-dev.qustodio.com';
  };

  return {
    getCurrent: () => qustodioCore.currentEnvironment,
    getSSOUrl,
  };
};

export default environment();
